export default "__VITE_ASSET__B0EJ6Xla__"